import { Request } from '@/classes/Request.ts'

export const logout = async (): Promise<void> => {
  const req = new Request()

  // If we have a Sanctum bearer token, delete it first.
  // This must happen BEFORE the session logout to avoid a race condition
  // where both requests read/write the same Redis session concurrently.
  const token = localStorage.getItem('auth_token')
  if (token) {
    try {
      await req.post('/ajax/family/logout')
    } catch {
      // 401 is expected if token is already expired — ignore
    }
  }

  // Always flush the session (this is the session-based logout).
  // Called last so its session state wins — no concurrent writes.
  try {
    await req.post('/ajax/logout')
  } catch {
    // May fail if session already expired — ignore
  }
}
